
  import {Component, Vue} from "vue-property-decorator";
  import api from '@/api';
  import {QuestionStatisticsDto} from "@/api/appService";
  import QuestionStatisticsItem from "./components/QuestionStatisticsItem.vue";

  @Component({
    components: {
      QuestionStatisticsItem
    }
  })
  export default class QuestionReport extends Vue {

    id!: number;
    statisticsResult: QuestionStatisticsDto[] = [];


    async created() {
      this.id = Number(this.$route.params.id);
      await this.fetchData();
    }

    async fetchData() {
      await api.question.getStatisticsResult({questionId: this.id}).then(res => {
        this.statisticsResult = res;
      });
    }
  }
